import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    remoteDataLoading: 0,
    userInfo: null
    // AllMachineModelInfoList: [],
    // AllAgentIDName: [],
    // AllVendorIDName: [],
    // AllShopIDName: []
  },
  getters: {
    // userType: state => {
    //   return state.userInfo.user_type;
    // }
  },
  mutations: {
    addRemoteDataLoading: state => {
      state.remoteDataLoading++;
    },
    reduceRemoteDataLoading: state => {
      state.remoteDataLoading--;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    }
    // setAllMachineModelInfoList(state, list) {
    //   state.AllMachineModelInfoList = list;
    // },

    // setAllAgentIDName(state, list) {
    //   state.AllAgentIDName = list;
    // },
    // setAllVendorIDName(state, list) {
    //   state.AllVendorIDName = list;
    // },
    // setAllShopIDName(state, list) {
    //   state.AllShopIDName = list;
    // }
  },
  actions: {}
});
